import {
  Flex,
  Icon,
  ListItem,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import { IconType } from "react-icons";
import { RiCheckboxMultipleBlankLine } from "react-icons/ri";

type Props = {
  icon: IconType;
  name: string;
  hasSubMenu: boolean;
  onClick: () => void;
};

export const MobileMenuItem = ({ icon, name, hasSubMenu, onClick }: Props) => {
  const targetIcon = useColorModeValue("gray.500", "gray.400");

  return (
    <ListItem
      as="button"
      w="100%"
      px="5"
      py="4"
      fontSize="1.2rem"
      textAlign="left"
      alignItems="center"
      onClick={onClick}
      _hover={{
        bgColor: "rgba(0,0,0, 0.04)"
      }}
    >
      <Flex>
        <Icon as={icon} boxSize="1.4rem" color="gray.300" />
        <Text ml="2" fontSize="md" fontWeight="light" w="full" isTruncated>
          {name}
        </Text>
        <Flex fontSize="1rem" color={targetIcon} alignItems="center" px={3}>
          {hasSubMenu ? <RiCheckboxMultipleBlankLine /> : null}
        </Flex>
      </Flex>
    </ListItem>
  );
};
